import { Component } from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Stock } from 'src/app/models/stock';
import { InventoryService } from 'src/app/services/inventory.service';
import { IconsService } from 'src/app/shared/services/icons.service';

@Component({
  selector: 'app-purchase-order-received-stock',
  template: `
    <div class="d-flex mb-4 mt-4">
      <h2>Orden de compra:</h2>
    </div>
    <div class="d-flex mb-4 mt-4">
      <div>
      <ul #subnav app-nav-inventory [currentView]="currentView" class="sidebar-zazz list-unstyled"></ul>
      </div>
      <div class="flex-fill ms-3">
        <div class="d-flex">          
          <div class="flex-fill">
            <button class="btn btn-zazz-default rounded-4 shadow-sm px-4 ms-2" ><!-- (click)="openModalLineItem()" -->
              <fa-icon [icon]="icons.faPlus" class="me-2"></fa-icon>
              Agregar
            </button>
          </div>
        </div>
        <div class="list-group rounded-5 shadow mt-4" >
          <div class="list-group-item w-100" >
          <table class="table table-sm" style="overflow-x: scroll;">
                <thead class="thead-dark">
                  <tr class="">
                    <th scope="col" class="text-start bg-zazz text-light py-2"># Parte <button class="btn p-0 text-light"><fa-icon [icon]="icons.faSort"></fa-icon></button></th>
                    <th scope="col" class="text-start bg-zazz text-light py-2">IPN </th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Revisión</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Descripción</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Estatus</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Lote</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Ubicación</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Fecha inventario</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Fecha expiración</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Última actualización</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Precio compra</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Paquete</th>
                    <th scope="col" class="text-center bg-zazz text-light py-2">Valor inventario</th>
                  </tr>
                </thead>
                <tbody>
                  <tr app-tr-inventory
                    [stock]="stk"
                    [profile]="profile" 
                    [permissions]="permissions"
                    *ngFor="let stk of stock | paginate: { itemsPerPage: payload.per_page, currentPage: p, totalItems: meta.total_entries }"
                  ></tr>
                </tbody>
              </table>
          </div>
        </div>
      </div>
    </div>
  `,
  styles: [
  ]
})
export class PurchaseOrderReceivedStockComponent {
  stock: Stock[] = [];
  profile: any = {};
  permissions: any = {};
  meta: any = {};

  payload: any = {};
  p: number = 1;

  currentView: string = 'purchaseOrders';
  
  constructor(
    private invService: InventoryService,
    private activeRoute: ActivatedRoute,
    public icons: IconsService
  ) { 
    this.activeRoute.params.subscribe(params => {
      this.loadStock(params['id']);
    });
  }

  loadStock(id: number) {
    this.invService.getPurchaseOrderReceivedStock(id).subscribe({
      next: (data) => {
        this.stock = data;
      },
      error: (error) => {
        console.error(error);
      }
    });
  }
}
